<template>
    <div class="gray-bg">
        <div class="center clearfix">
            <div class="succeed">
                <img :src="succeedImg" alt="资料提交成功">
                <h6 class="succeed-title">资料提交成功！请耐心等待！我们将尽快为您审核！</h6>
                <p class="succeed-text">资料提交成功后，位讯旅游工作人员将尽快与电话您联系。</p>
            </div>
        </div>
    </div>
</template>
<script>
export default {
    name: 'succeed',
    data () {
        return {
            sendSelected:'',
            colourClass:'white',
            session:'',
            succeedImg:'static/images/succeed.png',
        }
    },
    computed:{

    },
    methods:{
		UrlPath(){
            var Url = window.location.href;
            var UrlPath=Url.split('/');
            for(var i in UrlPath){
                if(UrlPath[i]=='cooperation'){
                    this.sendSelected='cooperation';
                }else if(UrlPath[i]=='league'){
                    this.sendSelected='league';
                }
            }
        }
    },
    beforeMount(){
        var self= this;
        var url = this.CustomerApplyView;
        this.session=sessionStorage.getItem('GWcustomer');
        this.UrlPath() // 路径判断达人还是供应商
        if(this.session==null){
            if(self.sendSelected=='cooperation'){
                self.$router.push({ path: '/cooperation' })
            }else if(self.sendSelected=='league'){
                self.$router.push({ path: '/league' })
            }
        }
    },
    mounted(){
        this.UrlPath() // 路径判断达人还是供应商
        this.$emit('nav',this.sendSelected,this.colourClass);
    },
    components:{
    },
  
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style lang="scss" scoped>
.succeed{
    padding: 85px 0;
    text-align: center;
    background-color: #fff;
    img{
        // margin: 0 auto 20px;
    }
    .succeed-title{
        font-size: 24px;
        line-height: 48px;
        color: #4bca57;
        text-align: center;
        margin: 20px 0;
    }
    .succeed-text{
        font-size: 14px;
        line-height: 18px;
        color: #999;
        text-align: center;
    }
    
}
</style>


// WEBPACK FOOTER //
// src/components/cooperation/succeed.vue